import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=21263e4f&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"
import style0 from "./Resource.vue?vue&type=style&index=0&id=21263e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21263e4f",
  null
  
)

export default component.exports